import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n\n  > div {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n  }\n\n  > div:first-child {\n    gap: 20px;\n    padding: 80px 0;\n    background-color: ",
        ";\n\n    > h1 {\n      font-size: 48px;\n      font-weight: 700;\n      color: ",
        ";\n    }\n  }\n\n  > div:nth-child(2) {\n    background-color: ",
        ";\n    padding: 80px 30px;\n    gap: 40px;\n    font-size: 24px;\n    font-weight: 700;\n    text-align: center;\n  }\n\n  > div:last-child {\n    background-color: ",
        ";\n    max-width: 1200px;\n    padding: 0 30px;\n    > p {\n      font-size: 24px;\n      font-weight: 600;\n    }\n  }\n  form {\n    width: 100%;\n    max-width: 996px;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    background-color: #fff;\n    position: relative;\n    box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);\n    padding: 32px 20px;\n    p {\n      font-size: 24px;\n      margin-bottom: 52px;\n    }\n    input {\n      width: 100%;\n      max-width: 680px;\n      border: unset;\n      border-bottom: 2px solid ",
        ";\n      display: inline-block;\n      margin-bottom: 36px;\n      text-align: center;\n      padding-bottom: 16px;\n      font-size: 24px;\n      &:focus {\n        outline: none !important;\n        border-bottom: 2px solid ",
        ";\n      }\n      ::placeholder {\n        text-align: center;\n        color: #d1d3d6;\n        font-weight: 700;\n      }\n    }\n    button {\n      max-width: 384px;\n      width: 100%;\n      font-size: 24px;\n      height: 56px;\n    }\n  }\n  @media (max-width: 768px) {\n    > div:first-child > h1 {\n      font-size: 32px;\n    }\n    > div:nth-child(2) {\n      font-size: 18px;\n    }\n    form > p {\n      font-size: 18px;\n    }\n    form > input {\n      font-size: 18px;\n    }\n    form > button {\n      font-size: 18px;\n      height: 36px;\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal([
        "\n  //border-bottom: 1px solid ",
        ";\n  margin-bottom: 80px;\n  width: 100%;\n  min-width: 996px;\n  thead {\n    font-weight: 600;\n    background-color: ",
        ";\n    border-bottom: 1px solid ",
        ";\n    border-top: 1px solid ",
        ";\n    tr {\n      text-align: center;\n    }\n  }\n\n  th,\n  td {\n    text-align: center;\n    font-size: 16px;\n    padding: 16px 24px;\n    line-height: 1.5;\n  }\n\n  tbody {\n    td {\n      vertical-align: top;\n    }\n  }\n  .empty {\n    text-align: center;\n    width: 100%;\n    background-color: rgba(27, 27, 41, 0.03);\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _tagged_template_literal([
        "\n  overflow: auto;\n  width: 100%;\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from "styled-components";
import { View } from "@/components";
import Icon from "@/components/icon/Icon";
import { UCILogo_w } from "@/components/icon/IconList";
import { Button } from "antd";
import { useForm } from "../../utils/form";
import { useQueryClient } from "@tanstack/react-query";
import { fetchUCI } from "../../api/uci";
import { useState } from "react";
const uciType = {
    handout: "수업자료",
    quiz: "문제"
};
const UciPage = ()=>{
    const [item, setItem] = useState(null);
    const queryClient = useQueryClient();
    const CODE_LENGTH = 21;
    const { values , setValue , submit , isSubmitting , isValidated , reset  } = useForm({
        code: ""
    }, {
        validator: (values)=>{
            const isValid = values.code.length === CODE_LENGTH;
            return [
                isValid,
                isValid ? undefined : "UCI 코드는 21자리 입니다."
            ];
        },
        onSubmit: async (done, param)=>{
            let { isValid , message  } = param;
            if (isValid) {
                try {
                    await fetchUciCode(values.code);
                    alert("UCI코드가 조회되었습니다.");
                    reset();
                } catch (e) {
                    var _e_response, _e_response_data;
                    alert("".concat((e === null || e === void 0 ? void 0 : (_e_response = e.response) === null || _e_response === void 0 ? void 0 : (_e_response_data = _e_response.data) === null || _e_response_data === void 0 ? void 0 : _e_response_data.message) || e.message));
                    done();
                }
            } else {
                alert("".concat(message));
            }
            done();
        }
    });
    const fetchUciCode = async (code)=>{
        const data = await queryClient.fetchQuery([
            "fetchUciCode",
            code
        ], ()=>fetchUCI({
                id: code.split("-")[1],
                type: "uci"
            }));
        setItem(data.uci);
    };
    return /*#__PURE__*/ _jsxs(UciPageWrapper, {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsx(Icon, {
                        icon: UCILogo_w
                    }),
                    /*#__PURE__*/ _jsx("h1", {
                        children: "UCI 코드를 조회해보세요"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsxs("p", {
                        children: [
                            "UCI 코드를 조회하여 ",
                            /*#__PURE__*/ _jsx("br", {}),
                            "정당한 저작권 이용 여부를 확인하세요."
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("form", {
                        onSubmit: (e)=>{
                            e.preventDefault();
                            submit();
                        },
                        children: [
                            /*#__PURE__*/ _jsx("p", {
                                children: "UCI 코드 조회"
                            }),
                            /*#__PURE__*/ _jsx("input", {
                                onChange: (e)=>setValue("code", e.target.value),
                                name: "code",
                                maxLength: CODE_LENGTH,
                                value: values.code,
                                type: "text",
                                placeholder: "UCI 코드를 입력하세요"
                            }),
                            /*#__PURE__*/ _jsx(Button, {
                                loading: isSubmitting,
                                disabled: !isValidated,
                                onClick: submit,
                                type: "primary",
                                children: "조회"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        children: "조회 결과"
                    }),
                    /*#__PURE__*/ _jsx(ScrollArea, {
                        children: /*#__PURE__*/ _jsxs(UciResultTable, {
                            children: [
                                /*#__PURE__*/ _jsx("thead", {
                                    children: /*#__PURE__*/ _jsxs("tr", {
                                        children: [
                                            /*#__PURE__*/ _jsx("th", {
                                                children: "UCI 코드"
                                            }),
                                            /*#__PURE__*/ _jsx("th", {
                                                children: "구분"
                                            }),
                                            (item === null || item === void 0 ? void 0 : item.data_type) === "quiz" && /*#__PURE__*/ _jsx("th", {
                                                children: "문제번호"
                                            }),
                                            /*#__PURE__*/ _jsx("th", {
                                                children: "자료명"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("tbody", {
                                    children: item ? /*#__PURE__*/ _jsxs("tr", {
                                        children: [
                                            /*#__PURE__*/ _jsx("td", {
                                                children: item.uci_code
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                children: uciType[item.data_type]
                                            }),
                                            item.data_type === "quiz" && /*#__PURE__*/ _jsx("th", {
                                                children: item.total_quiz
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                children: item.title
                                            })
                                        ]
                                    }) : /*#__PURE__*/ _jsx("tr", {
                                        children: /*#__PURE__*/ _jsx("td", {
                                            className: "empty",
                                            colSpan: 3,
                                            children: "조회결과가 없습니다."
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
export default UciPage;
const UciPageWrapper = styled(View).withConfig({
    componentId: "sc-70afe9d7-0"
})(_templateObject(), (props)=>props.theme.new.colors.gray900, (props)=>props.theme.new.colors.white, (props)=>props.theme.new.colors.gray30, (props)=>props.theme.new.colors.gray30, (props)=>props.theme.new.colors.black, (props)=>props.theme.new.colors.primary);
const UciResultTable = styled.table.withConfig({
    componentId: "sc-70afe9d7-1"
})(_templateObject1(), (props)=>props.theme.new.colors.gray200, (props)=>props.theme.new.colors.bg.gray, (props)=>props.theme.new.colors.gray100, (props)=>props.theme.new.colors.gray100, (props)=>props.theme.new.colors.gray600);
const ScrollArea = styled.div.withConfig({
    componentId: "sc-70afe9d7-2"
})(_templateObject2());
